import React from 'react';
import { PaddingContainer } from '@components';
import * as styles from './AreasOfExpertise.module.scss';
import classNames from 'classnames';
import { ServicesBlocks } from '../ServicesBlocks/ServicesBlocks';
import { areasOfExpertiseData } from '@store/AreasOfExpertiseData';

export const AreasOfExpertise: React.FC = () => {
	return (
		<PaddingContainer
			className={classNames(styles.paddingContainerAreas, 'gray-bg')}
		>
			<div className={styles.areasContainer}>
				<h2 className="font-size-medium-title font-600 mb-5">
					Areas of expertise
				</h2>
				<ServicesBlocks blocksData={areasOfExpertiseData} />
			</div>
		</PaddingContainer>
	);
};
